export default "__VITE_ASSET__C6fYI31l__"